import { countries } from './countries';

/** Long enough for a cold CDN edge, short enough that a stalled one cannot hold a page render. */
const GEO_FETCH_TIMEOUT_MS = 5_000;

export interface RegionsResponse {
	regions: Record<string, { name: string; provinces: Record<string, string> }>;
}

export async function fetchCountryRegions(country: string): Promise<
	| {
			code: string;
			name: string;
			provinces: { code: string; name: string }[];
	  }[]
	| undefined
> {
	const result = countries.find((c) => c.country === country);
	if (result?.url) {
		// Bounded: the partner-NGO directory calls this while rendering, and `Promise.all` waits for a stalled CDN.
		const response = await fetch(result.url, { signal: AbortSignal.timeout(GEO_FETCH_TIMEOUT_MS) });
		// A non-2xx body is usually the CDN's HTML error page, whose JSON parse error would not name the request.
		if (!response.ok) {
			throw new Error(`Region file for ${country} returned ${response.status.toString()}`);
		}
		return (response.json() as Promise<RegionsResponse>).then((data) =>
			Object.entries(data.regions)
				.map(([code, { name, provinces }]) => ({
					code,
					name,
					provinces: Object.entries(provinces)
						.map(([code, name]) => ({ code, name }))
						.toSorted((a, b) => a.name.localeCompare(b.name)),
				}))
				.toSorted((a, b) => a.name.localeCompare(b.name)),
		);
	}
}
